import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import validateAddNewWebsite from './validateAddNewWebsite';
import { useForm } from '../../../../hooks';
import { addNewContainerStart } from '../../../../redux/websites/websites.actions';
import useTranslation from 'hooks/useTranslation';
import './styles.scss';
import { isValidUrl } from 'utils';

const mapState = ({ appData }) => ({
  unregisteredUser: appData.unregisteredUser,
});

const WidgetGeneratingForm = (props) => {
  const [duplicateWebsite, setDuplicateWebsite] = useState(false);
  const dispatch = useDispatch();
  const { unregisteredUser } = useSelector(mapState);
  const { getTranslation } = useTranslation(['WEBSITES', 'AUTH']);
  const { t } = getTranslation();

  const handleAddNewWebsite = (values) => {
    const website = {
      ...unregisteredUser,
      ...values,
      setDuplicateWebsite,
    };
    dispatch(addNewContainerStart(website));
  };

  const { values, errors, handleChange, handleSubmit } = useForm(
    validateAddNewWebsite,
    handleAddNewWebsite,
    {
      title: '',
      url: '',
    }
  );

  const checkUrl = (url) => {
    if (url?.length > 0) {
      if (url.startsWith('https://')) {
        return url;
      }

      return `https://${url}`;
    }
  };

  const renderErrorMessage =
    values.url?.length < 1 ? (
      <span
        className={`error_message ${
          !isValidUrl(values.url) && errors.url ? 'visible' : ''
        }`}
      >
        {t('SITE_FIELDS_EMPTY')}
      </span>
    ) : !isValidUrl(values.url) && errors.url ? (
      <span
        className={`error_message ${
          !isValidUrl(values.url) && errors.url ? 'visible' : ''
        }`}
      >
        {t('SITE_UN_VALID')}
      </span>
    ) : duplicateWebsite ? (
      <span className={`error_message ${duplicateWebsite ? 'visible' : ''}`}>
        {t('SITE_REGISTERED_BEFORE')}
      </span>
    ) : null;

  const renderTitleErrorMessage = errors.title ? (
    <span className={`error_message ${errors.title ? 'visible' : ''}`}>
      {errors.title}
    </span>
  ) : null;

  return (
    <form
      className='form'
      id='Widget_generating_form'
      onSubmit={handleSubmit}
      noValidate
    >
      <div className='form_control flex input_container'>
        <input
          name='title'
          value={values.title}
          onChange={handleChange}
          className={clsx(errors.title && 'has-error')}
          type='text'
          placeholder={t('MODAL').ADD_WEBSITE_FORM_TITLE}
          id='siteTitle'
          autoFocus
        />
        {/* {errors.title && <div className='error'>{errors.title}</div>} */}
        {renderTitleErrorMessage}
      </div>
      <div className='form_control flex'>
        <input
          name='url'
          value={checkUrl(values.url)}
          onChange={handleChange}
          className={clsx((errors.url || duplicateWebsite) && 'has-error')}
          type='text'
          placeholder={t('MODAL').ADD_WEBSITE_FORM_ADDRESS}
          id='siteUrl'
        />
        {/* {errors.url && <div className='error'>{errors.url}</div>} */}
      </div>
      <div className='form_control flex button btn_container'>
        {renderErrorMessage}
        <input
          type='submit'
          value={t('GET_SCRIPT')}
          className='btn btn-primary'
        />
      </div>
    </form>
  );
};

export default WidgetGeneratingForm;
